import { render, staticRenderFns } from "./AddSerial.vue?vue&type=template&id=b3259804&lang=true&"
import script from "./AddSerial.js?vue&type=script&lang=js&"
export * from "./AddSerial.js?vue&type=script&lang=js&"
import style0 from "./AddSerial.vue?vue&type=style&index=0&id=b3259804&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports